import { useTranslation } from 'react-i18next';

import { faArrowRight, faPen } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@spacefill/uikit/src/components/Button';
import { IconButton } from '@spacefill/uikit/src/components/IconButton';

const AiChatOtherAnswer = ({ value, placeholder, autoFocus = false, onChange, onSubmit, onSkip, disabled }) => {
    const { t } = useTranslation();
    const hasValue = Boolean(value.trim());

    return (
        <div className='flex items-center gap-3 px-2 py-1.5'>
            <span className='flex size-6 shrink-0 items-center justify-center rounded-md bg-gray-100 text-xs text-gray-500'>
                <FontAwesomeIcon icon={faPen} />
            </span>
            <input
                type='text'
                value={value}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' && hasValue) {
                        event.preventDefault();
                        onSubmit();
                    }
                }}
                disabled={disabled}
                placeholder={placeholder}
                aria-label={placeholder}
                autoFocus={autoFocus}
                className='min-w-0 flex-1 border-none bg-transparent p-0 text-[13px] text-slate-900 outline-none placeholder:text-gray-400 focus:ring-0'
            />
            {hasValue || !onSkip ? (
                <IconButton
                    icon={faArrowRight}
                    label={t('Send')}
                    variant='secondary'
                    onClick={onSubmit}
                    disabled={disabled || !hasValue}
                />
            ) : (
                <Button
                    size='small'
                    variant='secondary'
                    onClick={onSkip}
                    disabled={disabled}
                    className='shrink-0'
                >
                    {t('Skip')}
                </Button>
            )}
        </div>
    );
};

export { AiChatOtherAnswer };
